import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import Import from '../components/Import';

import { selectLastImportPending, selectImportDetail } from '../services/selectors';
import { listenLastImport, unlistenLastImport } from '../services/actions';

export default compose(
    connect(
        state => ({
            showLoader: selectLastImportPending(state),
            lastImport: selectImportDetail(state),
        }),
        dispatch =>
            bindActionCreators(
                {
                    read: listenLastImport,
                    clear: unlistenLastImport,
                },
                dispatch,
            ),
    ),
    routeDependencies(),
    loadable,
)(Import);
